import React, { useContext, useState } from 'react'
import { CButton } from 'app/components/Common'
import { IconMoon, IconSunHigh } from '@tabler/icons-react'
import { ThemeContext } from 'theme/ThemeProvider'
import styled from 'styled-components'

import { useThemeStore } from 'app/hooks'

const DarkModeToggle = ({ size = 20 }) => {
	const { isDarkMode, toggleTheme } = useContext(ThemeContext)
	const [rotated, setRotated] = useState<boolean>(false)
	const { data: themeStore, mutate: mutateThemeStore } = useThemeStore()
	if (themeStore?.darkMode === undefined) {
		mutateThemeStore({
			darkMode: false,
		})
	}

	const icon = isDarkMode ? (
		<IconSunHigh color={'#000'} size={size} style={{ marginRight: 5 }} />
	) : (
		<IconMoon color={'#fff'} size={size} style={{ marginRight: 5 }} />
	)
	return (
		<Wrapper
			rotated={rotated}
			onClick={() => {
				toggleTheme()
				setRotated(true)
			}}>
			<CButton icon={icon} />
		</Wrapper>
	)
}

const Wrapper = styled.div<{ rotated?: boolean }>`
	transition: transform 0.2s ease-in-out;
	display: flex;
	cursor: pointer;
	align-items: center;
	&:active {
		transform: scale(0.95);
	}
	&:focus {
		outline: none;
		transform: scale(1.05);
	}
`
export default DarkModeToggle
